// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
  size: letter portrait;
  margin: 0.25in;
}
:host {
  display: block;
  min-height: 100vh;
  background: #eef1f4;
  color: #20252b;
}

.loading-state,
.message-state {
  display: flex;
  justify-content: center;
  padding: 3rem;
}

.pdf-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 52px;
  padding: 8px 16px;
  border-bottom: 1px solid #d6d6d6;
  background: #f7f7f7;
}

.toolbar-message {
  margin-left: 0.5rem;
  color: #66717d;
}
.toolbar-message.error {
  color: #b42318;
}

.pdf-actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.pdf-preview {
  display: block;
  width: 100%;
  height: calc(100vh - 53px);
  border: 0;
  background: #525659;
}

.report-document {
  box-sizing: border-box;
  width: 8.5in;
  max-width: 8.5in;
  min-height: 11in;
  margin: 24px auto;
  padding: 0.25in;
  background: #fff;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 6pt;
  line-height: 1.35;
}

.report-document.pdf-capture {
  margin: 0;
}
.report-document.pdf-capture ::ng-deep app-others-vertical .custom-report-scroll {
  overflow: visible;
}
.report-document.pdf-capture ::ng-deep app-others-vertical .custom-report-grid,
.report-document.pdf-capture ::ng-deep app-others-vertical .custom-report-cell {
  min-width: 0;
}
.report-document.pdf-capture ::ng-deep app-others-vertical .custom-report-table {
  table-layout: fixed;
  overflow-wrap: anywhere;
}

.report-document.pdf-capture.pdf-paginated {
  width: 100%;
  max-width: none;
  min-height: 0;
  padding: 0;
}

.report-header {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 0 0 12px;
  border-bottom: 3px solid #005f86;
}

.report-logo {
  width: 66px;
  height: 66px;
  object-fit: contain;
}

.report-heading {
  flex: 1;
}
.report-heading h1 {
  margin: 0;
  color: #18364a;
  font-size: 18pt;
  line-height: 1.15;
}
.report-heading p {
  margin: 5px 0 0;
  color: #5b6570;
}

.report-meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 12px;
  border: 2px solid #20252b;
  border-radius: 0;
  overflow: hidden;
  background: #fff;
}
.report-meta > div {
  display: flex;
  align-items: baseline;
  min-width: 0;
  min-height: 0;
  padding: 3px 5px;
  border-right: 1px solid #20252b;
  border-bottom: 1px solid #20252b;
}
.report-meta strong {
  color: #20252b;
  font-size: 7pt;
}
.report-meta strong::after {
  content: ":";
}
.report-meta span {
  margin-left: 3px;
  overflow-wrap: anywhere;
}
.report-meta > div:nth-child(4n+1) {
  border-right: 0;
}
.report-meta > div:nth-last-child(-n+4) {
  border-bottom: 0;
}
.report-meta > .report-meta-primary {
  grid-column: 1/-1;
  justify-content: center;
  gap: 3px;
}
.report-meta > .report-meta-primary strong:not(:first-child) {
  margin-left: 10px;
}

.report-section {
  margin-top: 12px;
}

h2,
h3,
h4 {
  color: #18364a;
}

h2 {
  margin: 0 0 6px;
  padding: 5px 8px;
  border-left: 5px solid #e1261c;
  background: #e9f0f4;
  font-size: 12pt;
}

.test-group-heading {
  margin: 0 0 6px;
  padding: 2px 4px;
  border: 2px solid #20252b;
  background: #9fc766;
  color: #20252b;
  font-size: 9pt;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-transform: uppercase;
  break-after: avoid;
  page-break-after: avoid;
}

h4 {
  margin: 0 0 4px;
  font-size: 9.5pt;
}

.custom-test-heading {
  margin-bottom: 0;
  padding: 2px 4px;
  border: 1px solid #20252b;
  background: #ffffe5;
  color: #20252b;
  text-align: center;
  break-after: avoid;
  page-break-after: avoid;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
table th,
table td {
  padding: 4px 6px;
  border: 1px solid #aebac3;
  overflow-wrap: anywhere;
  text-align: left;
  vertical-align: top;
}
table thead {
  display: table-header-group;
}
table tr {
  break-inside: avoid;
  page-break-inside: avoid;
}
table th {
  background: #dce8ee;
  color: #18364a;
  font-weight: 700;
}
table tbody tr:nth-child(even) {
  background: #f6f8f9;
}

.test-group,
.design-section {
  margin-top: 14px;
}

.test-group {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.test-section {
  margin-top: 0;
  padding: 7px;
}

.test-section > .test-group-heading {
  margin-right: -7px;
  margin-left: -7px;
}

.test-section > .design-title {
  margin-top: -7px;
  margin-right: -7px;
  margin-left: -7px;
}

.note-row td:last-child,
.test-note {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.test-note {
  margin: 6px 0 0;
  color: #4c5d69;
}

.design-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 6px;
}
.design-title h2 {
  flex: 1;
  margin: 0;
  padding: 2px 4px;
  border: 2px solid #20252b;
  background: #ffffa8;
  color: #20252b;
  font-size: 9pt;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-transform: uppercase;
  break-after: avoid;
  page-break-after: avoid;
}
.design-title span {
  padding: 0 8px 5px;
  color: #5b6570;
}

.equipment,
.empty-state {
  margin: 4px 0;
  color: #69747d;
  font-style: italic;
}

.report-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  padding-top: 6px;
  border-top: 1px solid #aebac3;
  color: #69747d;
  font-size: 7.5pt;
}

@media print {
  :host {
    background: #fff;
  }
  .no-print {
    display: none !important;
  }
  .report-document {
    width: 100%;
    max-width: none;
    min-height: 0;
    margin: 0;
    padding: 0;
  }
}
@media (max-width: 720px) {
  .pdf-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .pdf-preview {
    height: calc(100vh - 105px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-request-report/job-request-report.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,cAAA;AACF;AAEA;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,uBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;AAEE;EAAU,cAAA;AACZ;;AAEA;EACE,aAAA;EACA,cAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA;AACF;AAEI;EAAwB,iBAAA;AAC5B;AACI;;EACsB,YAAA;AAE1B;AAAI;EACE,mBAAA;EACA,uBAAA;AAEN;;AAGA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,OAAA;AAAF;AAEE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAAJ;AAGE;EACE,eAAA;EACA,cAAA;AADJ;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;AAIE;EACE,aAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,+BAAA;EACA,gCAAA;AAFJ;AAKE;EACE,cAAA;EACA,cAAA;AAHJ;AAME;EAAgB,YAAA;AAHlB;AAKE;EACE,gBAAA;EACA,uBAAA;AAHJ;AAME;EAA0B,eAAA;AAH5B;AAIE;EAA+B,gBAAA;AADjC;AAGE;EACE,iBAAA;EACA,uBAAA;EACA,QAAA;AADJ;AAGI;EAA2B,iBAAA;AAA/B;;AAIA;EACE,gBAAA;AADF;;AAIA;;;EAEK,cAAA;AAAL;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AACF;AACE;;EAEE,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEE;EAAQ,2BAAA;AACV;AACE;EACE,mBAAA;EACC,wBAAA;AACL;AAEE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AAGE;EAA2B,mBAAA;AAA7B;;AAGA;;EAEE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;AAAF;;AAGA;EACE,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AAAF;;AAGA;;EAEE,qBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,kBAAA;AAAF;AAEE;EACE,OAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,cAAA;AADJ;;AAKA;;EAEE,aAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE;IAAQ,gBAAA;EADR;EAEA;IAAY,wBAAA;EACZ;EAAA;IACE,WAAA;IACA,eAAA;IACA,aAAA;IACA,SAAA;IACA,UAAA;EAEF;AACF;AACA;EACE;IACE,uBAAA;IACA,sBAAA;EACF;EAEA;IAAe,2BAAA;EACf;AACF","sourcesContent":["@page {\n  size: letter portrait;\n  margin: 0.25in;\n}\n\n:host {\n  display: block;\n  min-height: 100vh;\n  background: #eef1f4;\n  color: #20252b;\n}\n\n.loading-state,\n.message-state {\n  display: flex;\n  justify-content: center;\n  padding: 3rem;\n}\n\n.pdf-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  min-height: 52px;\n  padding: 8px 16px;\n  border-bottom: 1px solid #d6d6d6;\n  background: #f7f7f7;\n}\n\n.toolbar-message {\n  margin-left: 0.5rem;\n  color: #66717d;\n\n  &.error { color: #b42318; }\n}\n\n.pdf-actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.pdf-preview {\n  display: block;\n  width: 100%;\n  height: calc(100vh - 53px);\n  border: 0;\n  background: #525659;\n}\n\n.report-document {\n  box-sizing: border-box;\n  width: 8.5in;\n  max-width: 8.5in;\n  min-height: 11in;\n  margin: 24px auto;\n  padding: 0.25in;\n  background: #fff;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 6pt;\n  line-height: 1.35;\n}\n\n.report-document.pdf-capture {\n  margin: 0;\n\n  ::ng-deep app-others-vertical {\n    .custom-report-scroll { overflow: visible; }\n\n    .custom-report-grid,\n    .custom-report-cell { min-width: 0; }\n\n    .custom-report-table {\n      table-layout: fixed;\n      overflow-wrap: anywhere;\n    }\n  }\n}\n\n.report-document.pdf-capture.pdf-paginated {\n  width: 100%;\n  max-width: none;\n  min-height: 0;\n  padding: 0;\n}\n\n.report-header {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 0 0 12px;\n  border-bottom: 3px solid #005f86;\n}\n\n.report-logo {\n  width: 66px;\n  height: 66px;\n  object-fit: contain;\n}\n\n.report-heading {\n  flex: 1;\n\n  h1 {\n    margin: 0;\n    color: #18364a;\n    font-size: 18pt;\n    line-height: 1.15;\n  }\n\n  p {\n    margin: 5px 0 0;\n    color: #5b6570;\n  }\n}\n\n.report-meta {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin-top: 12px;\n  border: 2px solid #20252b;\n  border-radius: 0;\n  overflow: hidden;\n  background: #fff;\n\n  > div {\n    display: flex;\n    align-items: baseline;\n    min-width: 0;\n    min-height: 0;\n    padding: 3px 5px;\n    border-right: 1px solid #20252b;\n    border-bottom: 1px solid #20252b;\n  }\n\n  strong {\n    color: #20252b;\n    font-size: 7pt;\n  }\n\n  strong::after { content: ':'; }\n\n  span {\n    margin-left: 3px;\n    overflow-wrap: anywhere;\n  }\n\n  > div:nth-child(4n + 1) { border-right: 0; }\n  > div:nth-last-child(-n + 4) { border-bottom: 0; }\n\n  > .report-meta-primary {\n    grid-column: 1 / -1;\n    justify-content: center;\n    gap: 3px;\n\n    strong:not(:first-child) { margin-left: 10px; }\n  }\n}\n\n.report-section {\n  margin-top: 12px;\n}\n\nh2,\nh3,\nh4 { color: #18364a; }\n\nh2 {\n  margin: 0 0 6px;\n  padding: 5px 8px;\n  border-left: 5px solid #e1261c;\n  background: #e9f0f4;\n  font-size: 12pt;\n}\n\n.test-group-heading {\n  margin: 0 0 6px;\n  padding: 2px 4px;\n  border: 2px solid #20252b;\n  background: #9fc766;\n  color: #20252b;\n  font-size: 9pt;\n  font-weight: 700;\n  line-height: 1.1;\n  text-align: center;\n  text-transform: uppercase;\n  break-after: avoid;\n  page-break-after: avoid;\n}\n\nh4 {\n  margin: 0 0 4px;\n  font-size: 9.5pt;\n}\n\n.custom-test-heading {\n  margin-bottom: 0;\n  padding: 2px 4px;\n  border: 1px solid #20252b;\n  background: #ffffe5;\n  color: #20252b;\n  text-align: center;\n  break-after: avoid;\n  page-break-after: avoid;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n\n  th,\n  td {\n    padding: 4px 6px;\n    border: 1px solid #aebac3;\n    overflow-wrap: anywhere;\n    text-align: left;\n    vertical-align: top;\n  }\n\n  thead { display: table-header-group; }\n\n  tr { \n    break-inside: avoid;\n     page-break-inside: avoid; \n    }\n\n  th {\n    background: #dce8ee;\n    color: #18364a;\n    font-weight: 700;\n  }\n\n  tbody tr:nth-child(even) { background: #f6f8f9; }\n}\n\n.test-group,\n.design-section {\n  margin-top: 14px;\n}\n\n.test-group {\n  display: flex;\n  flex-direction: column;\n  gap:0px;\n}\n\n.test-section {\n  margin-top: 0;\n  padding: 7px;\n}\n\n.test-section > .test-group-heading {\n  margin-right: -7px;\n  margin-left: -7px;\n}\n\n.test-section > .design-title {\n  margin-top: -7px;\n  margin-right: -7px;\n  margin-left: -7px;\n}\n\n.note-row td:last-child,\n.test-note {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.test-note {\n  margin: 6px 0 0;\n  color: #4c5d69;\n}\n\n.design-title {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 6px;\n\n  h2 {\n    flex: 1;\n    margin: 0;\n    padding: 2px 4px;\n    border: 2px solid #20252b;\n    background: #ffffa8;\n    color: #20252b;\n    font-size: 9pt;\n    font-weight: 700;\n    line-height: 1.1;\n    text-align: center;\n    text-transform: uppercase;\n    break-after: avoid;\n    page-break-after: avoid;\n  }\n\n  span {\n    padding: 0 8px 5px;\n    color: #5b6570;\n  }\n}\n\n.equipment,\n.empty-state {\n  margin: 4px 0;\n  color: #69747d;\n  font-style: italic;\n}\n\n.report-footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 18px;\n  padding-top: 6px;\n  border-top: 1px solid #aebac3;\n  color: #69747d;\n  font-size: 7.5pt;\n}\n\n@media print {\n  :host { background: #fff; }\n  .no-print { display: none !important; }\n  .report-document {\n    width: 100%;\n    max-width: none;\n    min-height: 0;\n    margin: 0;\n    padding: 0;\n  }\n}\n\n@media (max-width: 720px) {\n  .pdf-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pdf-preview { height: calc(100vh - 105px); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
